import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IAltenarState } from '../types'

const initialState: IAltenarState['data'] = {
  token: null,
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getSportToken.success, (state, action) => {
      state.token = action.payload
    })
    .addCase(actions.clearSportToken, state => {
      state.token = null
    })
})
